import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPO_REFUND_SUBSCRIPTION } from "../../../config/api";
import { getIpo } from "./getIpo";
import { getIpoSubscriptions } from "./getIpoSubscriptions";

export const refundIpoSubscription = createAsyncThunk(
  "ipos/refundSubscription",
  async (
    { subscriptionId, ipoId, reason, callback },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_IPO_REFUND_SUBSCRIPTION(subscriptionId),
        data: { reason },
      });
      toast.success(response?.data?.message || "Subscription refunded");
      if (ipoId) {
        dispatch(getIpo(ipoId));
        dispatch(getIpoSubscriptions({ id: ipoId }));
      }
      callback && callback();
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
